import { baseUrl } from '@/config/constants';
import { TDraftCategory } from '@/types';

export const fetchTourCateogry = async (tourId: number): Promise<TDraftCategory> => {
  const url = `${baseUrl}/tour/category/${tourId}`;
  const res = await fetch(url);

  if (!res.ok) {
    throw new Error('Failed getting tour category');
  }
  const data = await res.json();
  return data;
};
